import { Box, Typography ,Button} from "@mui/material";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { useGetConfilictInfo } from "../../../../hooks/into-warehouse/useGetConfilictInfo";
import AxiosT from "../../../../setup/setup-axios-bearer";
import CustomModal from "../../../global/custom-modal";
import LoadingSpinner from "../../../global/loading-spinner";
import ConfilictUpdate from "./confilict-update";

const ConfilictInfo = ({ id, closeModal }) => {
  const { data, isLoading } = useGetConfilictInfo(id);
  const [update , setUpdate] = useState(false);
  const queryClient = useQueryClient();

  const {mutate} = useMutation(()=>
    AxiosT.get(`conflict-delete?id=${id}`),
    {onSuccess: (data) =>{
      closeModal(false);
      queryClient.resetQueries(["getBuyFactordetail"]);
    }}
  );

  const handleRemove = () =>{
    mutate({
      id: id,
    })
  };

  const handleUpdate = () =>{
    setUpdate(true);
  }

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Box display="flex" mb={1}>
            <Typography variant="h3" ml={1} color="#ABACBE">
              تعداد کالا:
            </Typography>
            <Typography variant="h3">{data?.result.count}</Typography>
          </Box>
          <Box display="flex" mb={1}>
            <Typography variant="h3" ml={1} color="#ABACBE">
              تاریخ:
            </Typography>
            <Typography variant="h3">{data?.result.created_at}</Typography>
          </Box>
          <Box display="flex">
            <Typography variant="h3" ml={1} color="#ABACBE">
              توضیحات:
            </Typography>
            <Typography variant="h3">{data?.result.description}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mt={3}>
            <Button variant="outlined" style={{minWidth: '125px'}} onClick={handleRemove}>حذف</Button>
            <Button variant="contained" style={{minWidth: '125px'}} onClick={handleUpdate}>ویرایش</Button>
          </Box>
          <CustomModal openModal={update}
              setOpenModal={setUpdate}
              titleModal="ویرایش اطلاعات مغایرت کالا">
            <ConfilictUpdate id={id} closeModal={closeModal} />
          </CustomModal>
        </>
      )}
    </>
  );
};
export default ConfilictInfo;
